<template>
    <div class="container mt-5">
        <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status"></div>
            <p>جاري تحميل السؤال...</p>
        </div>
        <div v-else-if="noMoreQuestions" class="text-center">
            <!-- عرض رسالة عند عدم وجود أسئلة -->
            <p class="alert alert-warning">لا توجد المزيد من الأسئلة</p>
        </div>
        <div v-else>
            <div class="card shadow-lg p-4 question-box">
                <!-- Timer Section -->
                <div class="btn-quiz-box mt-5 mb-5">
                    <span class="bi" :class="question.is_favorite ? 'bi-heart-fill text-danger' : 'bi-heart text-muted'"
                        style="cursor: pointer; font-size: 20px;margin: 5px;padding: 10px 18px;cursor: pointer;font-size: 20px;"
                        @click="toggleFavorite(question)">
                    </span>

                    <span class="dropdown">
                        <button class="btn btn-secondary btn-smdropdown-toggle" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            خيارات <i class="fa fa-list"></i>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="addReport(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#add-report-modal">
                                    <i class="bi bi-flag-fill me-2"></i> بلاغ
                                </span>
                            </li>
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="addNote(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#add-note-modal">
                                    <i class="bi bi-journal-plus me-2"></i> أضف ملاحظة
                                </span>
                            </li>
                            <li>
                                <span class="dropdown-item" data-bs-toggle="modal"
                                    @click.prevent="showNotes(this.qbankId, this.question.id)" style="cursor: pointer;"
                                    data-bs-target="#show-note-modal">
                                    <i class="bi bi-journals me-2"></i> عرض الملاحظات
                                </span>
                            </li>

                        </ul>

                    </span>

                </div>
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <span class="dropdown">
                        <button style="color: #03c100; font-weight: 700;"
                            class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            سؤال رقم {{ questionNo }} من {{ lastQuestion }}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <!-- حلقة للتنقل بين الأسئلة من 1 إلى آخر سؤال -->
                            <li v-for="i in Array.from({ length: lastQuestion }, (_, index) => index + 1)" :key="i">
                                <span class="dropdown-item" :class="{ 'text-success': i === questionNo }"
                                    @click="goToQuestion(i)" style="cursor: pointer;">

                                    <!-- عرض العلامة إذا كانت ليست من قائمة الأسئلة غير المجابة -->
                                    <span v-if="!unanswered_questions.includes(i)"
                                        class="badge me-2 answered-circle"></span>

                                    سؤال رقم {{ i }} من {{ lastQuestion }}
                                </span>
                            </li>
                        </ul>
                    </span>

                    <div>
                        <span class="timer-text m-2">{{ formattedTime }}</span>
                        <button class="btn btn-sm btn-dark ml-2" @click="toggleTimer">
                            <i :class="timerRunning ? 'fas fa-pause' : 'fas fa-play'"></i>
                            {{ timerRunning ? 'إيقاف' : ' استئناف' }}
                        </button>

                    </div>
                </div>

                <!-- Question Content -->
                <h5 class="content-math card-title mb-4" v-html="cleanedContent(question.content)"
                    :dir="getDirection(question?.content)"></h5>
                <div v-if="question.file" style="text-align: center;">
                    <template v-if="isImage(question.file)">
                        <a :href="question.file" target="_blank">
                            <img style="max-height: 410px;" :src="question.file" alt="Question Image"
                                class="img-fluid mb-3" />
                        </a>
                    </template>
                    <template v-else>
                        <a :href="question.file" target="_blank" class="btn btn-link">📁 View File</a>
                    </template>
                </div>
                <div :dir="getDirection(question?.content)">
                    <div v-if="question.type === 3" class="text-question">
                        <!-- Text Question -->
                        <textarea v-if="!question.is_answered" v-model="userAnswer" class="form-control mb-3"
                            :readonly="question.is_answered" style="min-height: 150px;" rows="9"
                            placeholder="اكتب إجابتك هنا..."></textarea>

                        <div v-if="question.is_answered" class="mt-3 p-3 border rounded bg-light">

                            <!-- Display User Answer -->
                            <div v-if="question.is_correct == 1" class="alert alert-success p-2">
                                {{ getTranslation(question?.content).correct }}
                            </div>
                            <div v-else class="alert alert-danger p-2">
                                {{ getTranslation(question?.content).incorrect }}
                            </div>

                            <p><strong>إجابتك:</strong></p>
                            <div class="alert alert-dark p-2 mb-3">{{ question.user_answer }}</div>
                            <p><strong>الإجابة الصحيحة:</strong></p>
                            <div class="alert alert-primary p-2 mb-3">{{ question.correct_answer }}</div>
                            <!-- Correctness Feedback -->

                        </div>
                    </div>


                    <div v-else-if="question.type === 1" class="multi-choose p-3 border rounded bg-light">

                        <!-- ✅ نتيجة الإجابة في الأعلى -->
                        <b v-if="question.is_answered">
                            <span v-if="question.choices.some(c => c.is_correct && c.id == question.user_answer)"
                                class="text-success">
                                {{ getTranslation(question?.content).correct }}
                            </span>
                            <span v-else class="text-danger">
                                {{ getTranslation(question?.content).incorrect }}
                            </span>
                        </b>
                        <br>
                        <!-- الخيارات -->

                        <div v-for="choice in question.choices" :key="choice.id"
                            class="form-check mb-3 d-flex align-items-center" :class="{
                                'bg-success bg-opacity-25 rounded': choice.is_correct && question.user_answer == choice.id,
                                'bg-danger bg-opacity-25 rounded': question.is_answered && choice.id == question.user_answer && !choice.is_correct
                            }">
                            <label class="form-check-label flex-grow-1" :class="{
                                'text-success fw-bold': question.is_answered && choice.is_correct,
                                'text-danger fw-bold': question.is_answered && choice.id == question.user_answer && !choice.is_correct
                            }">
                                <input v-if="!question.is_answered" type="radio" :id="`choice-${choice.id}`"
                                    :value="choice.id" v-model="userAnswer" class="form-check-input me-2" />

                                <!-- الأيقونات بدلاً من الدوائر -->
                                <i v-if="question.is_answered && choice.is_correct"
                                    class="fa fa-check-circle me-2 text-success"></i>
                                <i v-else-if="question.is_answered && choice.id == question.user_answer"
                                    class="fa fa-times-circle me-2 text-danger"></i>
                                <i v-else-if="question.is_answered" class="fa fa-circle me-2 text-secondary"></i>

                                <span class="content-math" v-html="cleanedContent(choice.content)"></span>
                            </label>
                        </div>
                    </div>


                    <div v-else-if="question.type === 2" class="true-false-question p-3 border rounded bg-light"
                        style="margin:0 auto;width:200px">
                        <b v-if="question.is_answered">
                            <span v-if="question.choices.some(c => c.is_correct && c.id == question.user_answer)"
                                class="text-success">
                                {{ getTranslation(question?.content).correct }}
                            </span>
                            <span v-else class="text-danger">
                                {{ getTranslation(question?.content).incorrect }}
                            </span>
                        </b>
                        <br><br>
                        <div style="border: 1px solid #ddd;padding: 5px;border-radius: 10px;"
                            v-for="choice in question.choices" :key="choice.id"
                            class="form-check mb-3 d-flex align-items-center" :class="{
                                'bg-success bg-opacity-25 rounded': choice.is_correct && question.user_answer == choice.id,
                                'bg-danger bg-opacity-25 rounded': question.is_answered && choice.id == question.user_answer && !choice.is_correct
                            }">
                            <label class="form-check-label flex-grow-1" :class="{
                                'text-success fw-bold': question.is_answered && choice.is_correct,
                                'text-danger fw-bold': question.is_answered && choice.id == question.user_answer && !choice.is_correct
                            }">
                                <input v-if="!question.is_answered" type="radio" :id="`choice-${choice.id}`"
                                    :value="choice.id" v-model="userAnswer" class="form-check-input me-2" />

                                <!-- الأيقونات بدلاً من الدوائر -->
                                <i v-if="question.is_answered && choice.is_correct"
                                    class="fa fa-check-circle me-2 text-success"></i>
                                <i v-else-if="question.is_answered && choice.id == question.user_answer"
                                    class="fa fa-times-circle me-2 text-danger"></i>
                                <i v-else-if="question.is_answered" class="fa fa-circle me-2 text-secondary"></i>

                                <!-- التسمية -->
                                &nbsp;&nbsp; {{ choice.content }}
                            </label>
                        </div>
                    </div>



                    <div v-else-if="question.type === 4">
                        <!-- Matching Question -->
                        <div class="row">
                            <div v-if="question.is_correct == 1" class="m-1 alert alert-success text-center"> {{
                                getTranslation(question?.content).correct }}
                            </div>
                            <div v-else-if="question.is_correct == 0" class="m-1 alert alert-danger text-center">
                                {{ getTranslation(question?.content).incorrect }}
                            </div>
                            <div class="col-md-6">
                                <h5 class="">العناصر على اليسار</h5>
                                <ul class="list-group">
                                    <li v-for="item in question.matching_options.left" :key="item.id"
                                        class="list-group-item">
                                        <span class="content-math" v-html="cleanedContent(item.content)"></span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="question.is_answered" class="col-md-6">
                                <h5 class="">العناصر على اليمين</h5>
                                <ul class="list-group"
                                    :class="question.is_correct == 1 ? 'bg-success' : 'bg-secondary'">
                                    <li v-for="item in question.matching_options.right" :key="item.id"
                                        class="list-group-item">
                                        <span class="content-math" v-html="cleanedContent(item.content)"></span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="!question.is_answered" class="col-md-6">
                                <h5 class="">العناصر على اليمين</h5>
                                <ul class="list-group" ref="sortableRight">
                                    <li v-for="item in question.matching_options.right" :key="item.id"
                                        class="list-group-item">
                                        <span class="content-math" v-html="cleanedContent(item.content)"></span>
                                    </li>
                                </ul>
                            </div>
                            <hr class="text-primary mt-5">
                            <h3 v-if="question.is_answered" class="text-primary mt-2">الإجابة الصحيحة</h3>
                            <div v-if="question.is_answered" class="col-md-6">
                                <h5 class="">العناصر على اليسار</h5>
                                <ul class="list-group">
                                    <li v-for="item in question.correct_matching_pairs.left" :key="item.id"
                                        class="list-group-item">
                                        <span class="content-math" v-html="cleanedContent(item.content)"></span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="question.is_answered" class="col-md-6">
                                <h5 class="">العناصر على اليمين</h5>
                                <ul class="list-group" ref="sortableRight">
                                    <li v-for="item in question.correct_matching_pairs.right" :key="item.id"
                                        class="list-group-item">
                                        <span class="content-math" v-html="cleanedContent(item.content)"></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <h6 style="text-align: center; font-weight: 600; font-size: 12px;">
                        نسبة الإجابة الصحيحة بين جميع الطلاب
                        <span :class="question.correct_answers_percentage < 50 ? 'text-danger' : 'text-success'"
                            style="font-weight: 700;">
                            {{ question.correct_answers_percentage }} %
                        </span>
                    </h6>
                    <div v-if="question.is_answered && question.explanation">
                        <h6 class="mt-3">(Explanation) التوضيح :</h6>
                        <pre class="content-math" v-html="cleanedContent(question.explanation)"
                            style="font-family: 'SF Arabic' !important;"></pre>
                    </div>

                    <!-- عرض صورة التفسير أو رابط إذا كان موجود في explanation_file -->
                    <div v-if="question.is_answered && question.explanation_file">
                        <template v-if="isImage(question.explanation_file)">
                            <img :src="question.explanation_file" alt="Explanation Image" class="img-fluid mt-2" />
                        </template>
                        <template v-else>
                            <a :href="question.explanation_file" target="_blank" class="btn btn-link">📁 View
                                Explanation File</a>
                        </template>
                    </div>
                </div> <!-- Render question based on type -->


                <!-- Navigation Buttons -->
                <div class="d-flex justify-content-between mt-4">
                    <button class="btn btn-secondary" @click="previousQuestion">
                        <i class="fas fa-arrow-right"></i> السابق
                    </button>
                    <button v-if="this.answerRevealed == false" class="btn btn-secondary" @click="skipQuestion">
                        تخطي >>
                    </button>
                    <button class="btn btn-success" style="background-color: #03c100" @click="nextQuestion">
                        التالي <i class="fas fa-arrow-left"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <AddReport />
    <AddNote />
    <Notes ref="notesRef" />
    <HelpAi ref="aiRef" />

</template>

<script>
import { apiUrl } from "@/utils/api";
import Sortable from "sortablejs";
import Swal from "sweetalert2";
import AddReport from "../AddReport.vue";
import AddNote from "../AddNote.vue";
import Notes from "../Notes.vue";
import HelpAi from "../HelpAi.vue";

import {
    favoriteQuestion,
} from "@/utils/questionService";

export default {
    components: {
        AddReport,
        AddNote,
        Notes,
        HelpAi

    },
    data() {
        return {
            token: localStorage.getItem("access_token"),
            qbankId: this.$route.query.qref,
            lastQuestion: this.$route.query.total,
            quizMode: this.$route.query.mode,
            questionNo: Number(this.$route.query.num) || 1,
            question: null,
            answerRevealed: false,
            userAnswer: null,
            unanswered_questions: [],
            loading: true,
            timer: 0,
            timerInterval: null,
            timerRunning: true,
            noMoreQuestions: false,

        };
    },
    computed: {

        formattedTime() {
            const minutes = String(Math.floor(this.timer / 60)).padStart(2, "0");
            const seconds = String(this.timer % 60).padStart(2, "0");
            return `${minutes}:${seconds}`;
        },
    },

    updated() {
        this.renderMath();
    },
    methods: {
        cleanedContent(rawResponse) {

            return rawResponse.replace(/\\\\/g, "\\");

        },
        renderMath() {
            if (window.MathJax && window.MathJax.typesetPromise) {
                this.$nextTick(() => {
                    const elems = document.querySelectorAll('.content-math');

                    elems.forEach(el => {
                        if (el.textContent.includes('📐')) {
                            // نحذف الرمز 📐 من المحتوى
                            el.innerHTML = el.innerHTML.replace('📐', '');

                            // ثم نمرر العنصر إلى MathJax
                            MathJax.typesetPromise([el]);
                        }
                    });
                });
            }
        },
        async addNote(qbankNoteId, questionNoteId) {
            document.getElementById("qbankNoteId").value = qbankNoteId;
            document.getElementById("questionNoteId").value = questionNoteId;
        },
        isImage(file) {
            return /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(file);
        },
        async aiHelp(qbankHelpId, questionHelpId) {
            document.getElementById("questionHelpId").value = questionHelpId;
            this.$refs.aiRef.startExplanation();
        },
        async addReport(qbankReportId, questionReportId) {
            document.getElementById("qbankReportId").value = qbankReportId;
            document.getElementById("questionReportId").value = questionReportId;

        },
        async showNotes(qbankNoteId, questionNoteId) {
            document.getElementById("qbankNoteId").value = qbankNoteId;
            document.getElementById("questionNoteId").value = questionNoteId;
            this.$refs.notesRef.showNotes()
        },
        getDirection(text) {
            if (!text) return 'ltr';
            // إزالة الرموز والعلامات
            const cleanText = text.replace(/[:;.,/\()؟?!@#$%^&*[\]{}<>|_+=~`]/g, '');
            // التحقق من وجود أحرف عربية أو عبرية أو فارسية
            const rtlRegex = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
            return rtlRegex.test(cleanText) ? 'rtl' : 'ltr';
        },
        getTranslation(content) {
            return this.getDirection(content) === 'rtl'
                ? { correct: "✔ إجابتك صحيحة", incorrect: "✘ إجابتك خاطئة" }
                : { correct: "✔ Your answer is correct", incorrect: "✘ Your answer is incorrect" };
        },
        async toggleFavorite(question) {
            try {
                favoriteQuestion(question.id);
                // عكس الحالة في الواجهة مباشرة
                question.is_favorite = !question.is_favorite;

                alertify.success(
                    question.is_favorite ? "تمت الإضافة إلى المفضلة" : "تمت الإزالة من المفضلة"
                );
            } catch (err) {
                console.error(err);
                alertify.error("حدث خطأ، حاول لاحقًا");
            }
        },
        favoriteQuestion,

        async fetchQuestion() {
            this.loading = true;
            this.noMoreQuestions = false; // إعادة تعيين الحالة عند كل طلب
            try {
                const response = await fetch(
                    `${apiUrl}/qbanks/${this.qbankId}/questions?number=${this.questionNo}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    if (!data.question) {
                        throw new Error("No more questions");
                    }
                    this.question = data.question;
                    this.unanswered_questions = data.unanswered_questions;

                    this.userAnswer = null;

                    // Initialize SortableJS for matching questions
                    if (this.question.type === 4 && this.question.matching_options?.right) {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.initSortable();
                            }, 2000);
                        });
                    }
                } else if (response.status === 404) {
                    this.noMoreQuestions = true; // تعيين الحالة عند عدم وجود أسئلة
                } else {
                    console.error("فشل جلب الأسئلة");
                }
            } catch (error) {
                console.error("خطأ في جلب الأسئلة:", error);
                this.noMoreQuestions = true; // عرض رسالة عند أي خطأ
            } finally {
                this.loading = false;
            }
        },
        async skipQuestion() {
            if (this.questionNo == this.lastQuestion) {
                this.nextQuestion();
                return;
            }
            // إعادة تعيين الحالة، والانتقال للسؤال التالي
            this.answerRevealed = false;
            this.questionNo += 1;
            this.updateUrl();
            this.fetchQuestion();
            this.destroySortable();
        },
        async nextQuestion() {
            // تحقق إذا كنا في وضع "tutor"
            // لو الإجابة لم تُعرض بعد
            if (!this.answerRevealed && !this.question.is_answered) {


                await this.submitAnswer();
                this.answerRevealed = true; // خليها true عشان المرة الجاية ينتقل للسؤال التالي
                // إعادة تعيين الحالة، والانتقال للسؤال التالي

                this.updateUrl();
                this.fetchQuestion();
                this.destroySortable();

            } else {
                if (this.questionNo == this.lastQuestion) {
                    const unansweredList = this.unanswered_questions;
                    let unansweredMessage = "";

                    if (unansweredList.length > 0) {
                        if (unansweredList.length > 10) {
                            unansweredMessage = `لديك أكثر من 10 أسئلة غير مجابة`;
                        } else {
                            unansweredMessage = ` لم تجب على هذه الأسئلة بعد    : ${unansweredList.join(", ")}`;
                        }
                    } else {
                        unansweredMessage = "";
                    }

                    // رسالة التنبيه
                    const confirmed = await Swal.fire({
                        title: "تأكيد إنهاء الاختبار",
                        html: `<p>هل أنت متأكد أنك تريد إنهاء الاختبار؟</p>
               <p style="color: #db1e1e;">${unansweredMessage}</p>`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "نعم، أكمل الاختبار",
                        cancelButtonText: "إلغاء",
                    });

                    if (confirmed.isConfirmed) {
                        //await this.submitAnswer();
                        await this.completeQuiz();
                    }
                    return;
                }
                // إعادة تعيين الحالة، والانتقال للسؤال التالي
                this.answerRevealed = false;
                this.questionNo += 1;
                this.updateUrl();
                this.fetchQuestion();
                this.destroySortable();

            }
            // لو مش في وضع "tutor"

        },
        async completeQuiz() {
            try {
                const response = await fetch(
                    `${apiUrl}/qbanks/${this.qbankId}/complete`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                        },
                    }
                );
                if (response.ok) {
                    Swal.fire("تم بنجاح", "تم إنهاء الاختبار.", "success");
                    window.location.href = "qbank-summary?qbank=" + this.qbankId;
                } else {
                    Swal.fire("خطأ", "حدث خطأ أثناء إنهاء الاختبار.", "error");
                    window.location.href = "qbank-summary?qbank=" + this.qbankId;

                }
            } catch (error) {
                Swal.fire("خطأ", "تعذر الاتصال بالخادم.", "error");
            }
        },
        goToQuestion(questionNum) {
            this.questionNo = questionNum;
            // تحديث الـ URL بناءً على السؤال المختار
            this.$router.push({ query: { ...this.$route.query, num: this.questionNo } });
            this.fetchQuestion();
        },
        previousQuestion() {
            if (this.questionNo > 1) {
                this.questionNo -= 1;
                this.updateUrl();
                this.fetchQuestion();
                this.destroySortable();
            }
        },
        toggleTimer() {
            this.timerRunning = !this.timerRunning;

            // تشغيل أو إيقاف التايمر بناءً على الحالة
            if (this.timerRunning) {
                this.startTimer();
            } else {
                clearInterval(this.timerInterval);
            }

            // تحديد الرابط المناسب بناءً على حالة التايمر
            const endpoint = this.timerRunning
                ? `${apiUrl}/qbanks/${this.qbankId}/resume`
                : `${apiUrl}/qbanks/${this.qbankId}/pause`;

            // تنفيذ طلب الـ API
            fetch(endpoint, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${this.token}`,
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log("Response:", data);

                    // إشعار بسيط باستخدام alert
                })
                .catch(error => {

                });
        },
        startTimer() {
            this.timerInterval = setInterval(() => {
                this.timer++;
            }, 1000);
        },

        updateUrl() {
            this.$router.push({ query: { ...this.$route.query, num: this.questionNo } });
        },
        async submitAnswer() {
            try {
                const formData = new FormData();

                // إعداد البيانات بناءً على نوع السؤال
                if (this.question.type === 3) {
                    // سؤال نصي
                    formData.append("answer", this.userAnswer);
                } else if (this.question.type === 1 || this.question.type === 2) {
                    // اختيار من متعدد أو صح/خطأ
                    formData.append("answer", this.userAnswer);
                } else if (this.question.type === 4) {
                    // مطابقة
                    this.question.matching_options.right.forEach((item, index) => {
                        formData.append(`answer[${index}][left_option_id]`, this.question.matching_options.left[index].id);
                        formData.append(`answer[${index}][right_option_id]`, item.id);
                    });
                }

                // إرسال الطلب إلى الخادم
                const response = await fetch(
                    `${apiUrl}/qbanks/${this.qbankId}/questions/${this.question.id}`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${this.token}`, // لا يتم تضمين Content-Type مع FormData
                        },
                        body: formData,
                    }
                );

                if (!response.ok) {
                    Swal.fire({
                        icon: "error",
                        title: "خطأ",
                        text: "حدث خطأ أثناء إرسال الإجابة. حاول مرة أخرى.",
                    });
                    return;
                }

                /* Swal.fire({
                     icon: "success",
                     title: "تم الإرسال",
                     text: "تم إرسال الإجابة بنجاح!",
                 });*/
            } catch (error) {
                /*Swal.fire({
                    icon: "error",
                    title: "خطأ",
                    text: "حدث خطأ أثناء إرسال الإجابة. حاول مرة أخرى.",
                });*/
                this.answerRevealed = false;
                this.questionNo += 1;
                this.updateUrl();
                this.fetchQuestion();
                this.destroySortable();
                console.error("حدث خطأ أثناء إرسال الإجابة:", error);
            }
        },

        initSortable() {
            const sortableRight = this.$refs.sortableRight;
            if (!sortableRight) return;

            Sortable.create(sortableRight, {
                group: "matching",
                animation: 150,
                onEnd: (evt) => {
                    const newOrder = Array.from(sortableRight.children).map((child) => {
                        return this.question.matching_options.right.find(
                            (item) => item.content === child.innerText.trim()
                        );
                    });

                    this.question.matching_options.right = newOrder;
                },
            });
        },
        destroySortable() {
            const sortableRight = this.$refs.sortableRight;
            if (sortableRight && sortableRight._sortable) {
                sortableRight._sortable.destroy();
            }
        },
    },
    mounted() {
        this.fetchQuestion();
        this.startTimer();
        this.renderMath();

    },
    beforeDestroy() {
        clearInterval(this.timerInterval);
    },
};
</script>

<style scoped>
.card {
    border-radius: 10px;
    border: 1px solid #07b12c;
}

.timer-text {
    font-size: 1.2rem;
    color: #ff5722;
    font-weight: bold;
}

textarea {
    resize: none;
}

.list-group-item {
    cursor: move;
}

.btn-outline-primary {
    font-size: 1.2rem;
    padding: 10px 20px;
    transition: all 0.3s ease;
    background-color: #9e9e9e1c;
}

.btn-outline-primary:hover,
.btn-outline-primary.active {
    background-color: #07b12c;
    color: #fff;
    border-color: #07b12c;
}

.answered-circle {
    padding: 4px;
    width: 5px !important;
    height: 4px;
    display: inline-block;
    /* border-radius: 72%; */
    background-color: #1a82e9
        /* اللون الأزرق الداكن */
}

.swal2-actions {
    font-family: 'SF Arabic' !important;
}

.content-math {
    display: inline;
    /* تأكد أنه ما ينزل سطر */
    margin: 0;
    padding: 0;
    line-height: 1.4;
}
</style>